/**
 * Stellt Helfermethoden für Stringberechnungen bereit. 
 *
 * @class service_v3sStringService
 * @memberOf v3sWbtPlayerApp:helper
 */
angular.module('v3sWbtPlayerApp').factory('v3sStringService', function () {
    function levenshteinDistance(str1, str2) {
        var m = str1.length,
                 n = str2.length,
                 d = [],
                 i, j;

        if (!m) return n;
        if (!n) return m;

        for (i = 0; i <= m; i++) d[i] = [i];
        for (j = 0; j <= n; j++) d[0][j] = j;

        for (j = 1; j <= n; j++) {
            for (i = 1; i <= m; i++) {
                if (str1[i - 1] == str2[j - 1]) d[i][j] = d[i - 1][j - 1];
                else d[i][j] = Math.min(d[i - 1][j], d[i][j - 1], d[i - 1][j - 1]) + 1;
            }
        }
        return d[m][n];
    }

    function equalsWithTolerance (str, correctStr, tolerance) {
        if (typeof correctStr == 'string' && typeof str == 'string' && correctStr.length > 0) {
            var distance = levenshteinDistance(str, correctStr);
            var distanceTolerance = 1 - distance / correctStr.length;
            if (distanceTolerance >= tolerance) {
                return true;
            }
        }
        return false;
    };

    /**
     * Berechnet die Länge des Textes in diesem Element
     * @memberOf v3sWbtPlayerApp:helper.service_v3sStringService
     * @param element - ein Angular-Element
     * @return die Textlänge
     */
    function textLength(element) {
        var text = element.text();
        return text.length;
    }

    return {
        levenshteinDistance: levenshteinDistance,
        equalsWithTolerance: equalsWithTolerance,
        textLength: textLength
    }
});